module.exports = __webpack_public_path__ + "mobile/img/icon_circle_down.36812504.png";